import React from "react";
import { times } from "ramda";
import { Formik } from "formik";
import { Container } from "components/generic/layout";
import { Button } from "components/generic/kit";
import * as formik from "components/generic/form/formik";
import { ErrorBox } from "components/generic/form/service";
import * as feedbackModel from "modules/feedback/model";
import RateItem from "./RateItem";

export default ({
  initialValues,
  validationSchema,
  onSubmit,
  info: {
    data: { completed, introduction, responses, title_general_feedback }
  },
  footer,
  submitApi,
  errors
}) => (
  <Container>
    {completed ? (
      <div className="pv6">
        <h1 className="f3 f2-m f1-l fw2 black-90 mv3 tc relative center top-25 pl5 pr5">
          You have already submitted your review
        </h1>
      </div>
    ) : (
      <div className="pv5">
        <div className="fw6 mb3">Feedback collection</div>
        <Formik
          onSubmit={onSubmit}
          initialValues={initialValues}
          validationSchema={validationSchema}
        >
          {props => (
            <form onSubmit={props.handleSubmit} className="bg-white pa3 br2 f6">
              {!!errors.nonField.length && (
                <ErrorBox errors={errors.nonField} />
              )}
              <Text>{introduction}</Text>
              <div className="pt2">
                {feedbackModel
                  .getQuestions(responses)
                  .map(({ id, title, questions }) => (
                    <div key={id}>
                      <div className="f5 fw7 mb1">{title}</div>
                      <div>
                        {questions.map(({ id, question }) => (
                          <div key={id}>
                            <Text>{question.title}</Text>
                            <div className="mb3 flex items-center">
                              {times(
                                i => (
                                  <RateItem
                                    type="radio"
                                    key={i}
                                    name={id.toString()}
                                    value={i + 1}
                                  >
                                    {i + 1}
                                  </RateItem>
                                ),
                                question.max_int_response
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                <div className="f5 fw7 mb1">{title_general_feedback}</div>
                <div className="measure">
                  <formik.Textarea rows="6" name="general" />
                </div>
                {footer && <div className="mt2">{footer}</div>}
                <Text>
                  If you have any more extensive feedback, please don't be shy
                  and reach out to the team at team@thelobby.io.
                </Text>
                <div className="mt3">
                  <Button disabled={!props.isValid || submitApi.isFetching}>
                    Submit feedback
                  </Button>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </div>
    )}
  </Container>
);

const Text = ({ children }) => (
  <div className="black-60 mb2 lh-title">{children}</div>
);



// WEBPACK FOOTER //
// ./src/components/common/feedback/LeaveFeedback/View.js